import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useFormContext from "./GetEventMarsComplete.jsx/useFormMarsComplete";
import "reactjs-popup/dist/index.css";
import ConfirmationModalDecline from "./GetEventMarsComplete.jsx/ConfirmationModalDecline";
import AdditionalPopupDecline from "./GetEventMarsComplete.jsx/AdditionalPopup";
import ConfirmationModalAccept from "./GetEventMarsComplete.jsx/ConfirmationModalAccept";
import AdditionalPopupAccept from "./GetEventMarsComplete.jsx/AdditionalPopupAccept";
import ConfirmationModalTentative from "./GetEventMarsComplete.jsx/ConfirmationModalTentative";
import AdditionalPopupTentative from "./GetEventMarsComplete.jsx/AdditionalPopupTentative";
import {
  GET_VCS_FILE
} from './ApiDetails.js';
import axios from "axios";

export default function Footer({userIsEventRequestor}) {
  const {
    eventFormData,
    ProcessEventInvitation,
    userAcceptConfirmed,
    userDeclined,
    userTentative,
    handleSubmitLight
  } = useFormContext();
  
    const navigateToApp = (role) => {
        // Role-based redirection
        switch (role) {
            case 'Visit Requester':
            case 'Requester':
                navigate('/AppRequester');
                break;
            case 'Admin':
                navigate('/AppAdmin');
                break;
            case 'Family':
                navigate('/AppFamily');
                break;
            case 'MLTUser':
                navigate('/AppMltEvent');
                break;
            case 'FamilyCoordinator':
                navigate('/AppFamily');
                break;
            case 'MLTCoordinator':
                navigate('/AppMltEvent');
                break;
            default:
                navigate('/');  // Redirect to home or login in case of an invalid role
                break;
        }
    }

  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [isTentativeModalOpen, setIsTentativeModalOpen] = useState(false);
  const [isAdditionalPopupDeclineOpen, setIsAdditionalPopupDeclineOpen] = useState(false);
  const [isAdditionalPopupAcceptOpen, setIsAdditionalPopupAcceptOpen] = useState(false);
  const [isAdditionalPopupTentativeOpen, setIsAdditionalPopupTentativeOpen] = useState(false);
  const userRootRole = localStorage.getItem('rootRole');
  var impersonatedUser = JSON.parse(localStorage.getItem('impersonatedUser')) || null;

  //for decline invitation
  const handleDeclineClick = () => {
    setIsDeclineModalOpen(true);
  };

  const handleDeclineSaveClick = (comment, emailNotifGuest, emailNotifRequestor) => {
    ProcessEventInvitation("Declined", comment, emailNotifGuest, emailNotifRequestor);
    setIsDeclineModalOpen(false);
    setIsAdditionalPopupDeclineOpen(true);
  };

  const handleDeclineCancelClick = (e) => {
    e.preventDefault();
    setIsDeclineModalOpen(false);
  };

  const handleAdditionalPopupDeclineClose = () => {
    setIsAdditionalPopupDeclineOpen(false);
  };

  // for accept invitation

  const handleAcceptClick = () => {
    setIsAcceptModalOpen(true);
  };

  const handleAcceptSaveClick = (comment, emailNotifGuest, emailNotifRequestor) => {
    ProcessEventInvitation("Confirmed", comment, emailNotifGuest, emailNotifRequestor);
    setIsAcceptModalOpen(false);
    setIsAdditionalPopupAcceptOpen(true);
    navigateToApp(localStorage.getItem('role'));
  };

  const handleAcceptCancelClick = (e) => {
    e.preventDefault();
    setIsAcceptModalOpen(false);
  };

  const handleAdditionalPopupAcceptClose = () => {
    setIsAdditionalPopupAcceptOpen(false);
  };

  // for tentative invitation

  const handleTentativeClick = () => {
    setIsTentativeModalOpen(true);
  };

  const handleTentativeSaveClick = (comment, emailNotifGuest, emailNotifRequestor) => {
    ProcessEventInvitation("Tentative", comment, emailNotifGuest, emailNotifRequestor);
    setIsTentativeModalOpen(false);
    setIsAdditionalPopupTentativeOpen(true);
  };

  const handleTentativeCancelClick = (e) => {
    e.preventDefault();
    setIsTentativeModalOpen(false);
  };

  const handleAdditionalPopupTentativeClose = () => {
    setIsAdditionalPopupTentativeOpen(false);
  };

  const fileDownload = require('js-file-download');
  const downloadVCSFile = () => {
    axios.get(`${GET_VCS_FILE}/${eventFormData.eventId}`)
      .then(response => {
        fileDownload(response.data, `${eventFormData.eventTitle}_${eventFormData.eventId}.vcs`);
      })
      .catch(error => {
        console.error('Error updating the details: ', error);
      });
  }

  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row footerButtonsContainer">
          <div className="col-md-6">
            <button
              type="button"
              className="btn btn-outline-light left-button"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          {eventFormData.eventStatus !== 'Completed' ?
            (
              <div className="col-md-6 text-end">
                {userIsEventRequestor && (
                <button
                    id="saveChanges"
                    className="btn btn-outline-light right-buttons footerButtons"
                    onClick={handleSubmitLight}
                >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M1.83254 1.53125L1.83254 7.63341L9.16746 7.63341L9.16746 3.45388L8.04612 2.33254H6.57866L6.57866 4.36659L2.72629 4.36659L2.72629 2.33254H1.83254L1.83254 1.53125ZM1.83254 1.53125L8.37802 1.53125L9.96875 3.12198L9.96875 9.66746C9.96875 10.11 9.61 10.4688 9.16746 10.4688L1.83254 10.4688C1.39 10.4688 1.03125 10.11 1.03125 9.66746L1.03125 2.33254C1.03125 1.89 1.39 1.53125 1.83254 1.53125ZM3.52759 2.33254L3.52759 3.5653L5.77737 3.5653V2.33254L3.52759 2.33254ZM9.16746 8.4347H1.83254L1.83254 9.66746L9.16746 9.66746V8.4347Z" fill="white" />
                    </svg>
                    <span>SAVE CHANGES</span>
                </button>
                )}
                {(((userRootRole!=="FamilyCoordinator") && (userRootRole!=="MLTCoordinator")) || (impersonatedUser!==null)) && (!userDeclined && ((eventFormData.eventStatus === "Open event") || (eventFormData.eventStatus === "Attendance confirmed"))) && (
                  <button type="button" id="rejectEvent" className="btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                    onClick={handleDeclineClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 1 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                    </svg>
                    <span>DECLINE INVITATION</span>
                  </button>
                )}

                {(((userRootRole!=="FamilyCoordinator") && (userRootRole!=="MLTCoordinator")) || (impersonatedUser!==null)) && (!userTentative && ((eventFormData.eventStatus === "Open event") || (eventFormData.eventStatus === "Attendance confirmed"))) && (
                  <button
                    type="button"
                    id="ReturnToRequestor"
                    className="btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                    onClick={handleTentativeClick}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                      <path d="M12 22a10 10 0 1110-10 10.011 10.011 0 01-10 10zm0-18a8 8 0 108 8 8.009 8.009 0 00-8-8zm4 9h-5a1 1 0 01-1-1V7a1 1 0 112 0v4h4a1 1 0 010 2z" />
                    </svg>
                    <span>TENTATIVE</span>
                  </button>
                )}

                {(((userRootRole!=="FamilyCoordinator") && (userRootRole!=="MLTCoordinator")) || (impersonatedUser!==null)) && (!userAcceptConfirmed && ((eventFormData.eventStatus === "Open event") || (eventFormData.eventStatus === "Attendance confirmed"))) && (
                  <button
                    type="button"
                    id="ValidateOpen"
                    className="buttonrequest btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                    onClick={handleAcceptClick}
                  >
                    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg"                  >
                      <path d="M1.16523 3.72227L0.615234 4.27227L2.16211 5.81914C2.33398 5.99102 2.64336 5.99102 2.84961 5.81914L8.31524 0.353516L7.24961 0.353516L2.54023 5.06289L1.16523 3.72227Z" fill="currentColor" />
                    </svg>
                    <span>ACCEPT INVITATION</span>
                  </button>
                )}

                {(((userRootRole!=="FamilyCoordinator") && (userRootRole!=="MLTCoordinator")) || (impersonatedUser!==null)) && userAcceptConfirmed && (
                  <a href="#" onClick={(e) => { e.preventDefault(); downloadVCSFile(); }}>
                    <button
                      type="button"
                      id="AddToCalendar"
                      className="buttonrequest btn btn-outline-light right-buttons footerButtons footerButtonsMarsf"
                    >
                      <span>Add event to your Outlook calendar</span>
                    </button>
                  </a>
                )}

                <ConfirmationModalAccept
                  isOpen={isAcceptModalOpen}
                  onClose={() => setIsAcceptModalOpen(false)}
                  onSave={(comment,emailNotifGuest,emailNotifRequestor) => handleAcceptSaveClick(comment,emailNotifGuest,emailNotifRequestor)}
                  onCancel={handleAcceptCancelClick}
                  commentMandatory={false}
                  placeHolderText="I accept this invitation."
                  notifOptions={(userRootRole!=="FamilyCoordinator") && (userRootRole!=="MLTCoordinator") ? "false" : "true"}
                />
                <AdditionalPopupAccept
                  isOpen={isAdditionalPopupAcceptOpen}
                  onClose={handleAdditionalPopupAcceptClose}
                />
                <ConfirmationModalTentative
                  isOpen={isTentativeModalOpen}
                  onClose={() => setIsTentativeModalOpen(false)}
                  onSave={(comment,emailNotifGuest,emailNotifRequestor) => handleTentativeSaveClick(comment,emailNotifGuest,emailNotifRequestor)}
                  onCancel={handleTentativeCancelClick}
                  commentMandatory={false}
                  placeHolderText="I might accept this invitation."
                  notifOptions={(userRootRole!=="FamilyCoordinator") && (userRootRole!=="MLTCoordinator") ? "false" : "true"}
                />
                <AdditionalPopupTentative
                  isOpen={isAdditionalPopupTentativeOpen}
                  onClose={handleAdditionalPopupTentativeClose}
                />
                <ConfirmationModalDecline
                  isOpen={isDeclineModalOpen}
                  onClose={() => setIsDeclineModalOpen(false)}
                  onSave={(comment,emailNotifGuest,emailNotifRequestor) => handleDeclineSaveClick(comment,emailNotifGuest,emailNotifRequestor)}
                  onCancel={handleDeclineCancelClick}
                  commentMandatory={true}
                  placeHolderText="I decline this invitation."
                  notifOptions={(userRootRole!=="FamilyCoordinator") && (userRootRole!=="MLTCoordinator") ? "false" : "true"}
                />
                <AdditionalPopupDecline
                  isOpen={isAdditionalPopupDeclineOpen}
                  onClose={handleAdditionalPopupDeclineClose}
                />
              </div>
            ) :
            (
              <div className="col-md-6 text-end"></div>
            )
          }
        </div>
      </div>
    </footer>
  );
}
